<template>
<div>
    <button class="btn btn-sm btn-xs btn-warning mr-2 font-weight-bolder"
            data-toggle="modal"
            data-target="#add-vessel-flag"
            v-if="(isSystemAdmin || isPrincipal || isPrincipalStaff || isDesignatedPrincipal) && !isKline"
    >
        <span class="fas fa-flag"></span>
        Add Flag History Record
    </button>

    <cms-modal unique="add-vessel-flag" title="Add Flag History">

        <form @submit.prevent="confirmAddVesselFlag">
            <div class="form-group form-row mb-1" :class="{'has-error': newVesselFlagErrors.vessel_name}">
                <label for="new-vessel-name" class="col col-sm-3 col-form-label font-weight-bolder">
                    Vessel Name:
                </label>
                <div class="col col-sm-8 offset-1 col-form-label p-0">
                    <input type="text" id="new-vessel-name" required
                           class="form-control form-control-xs"
                           placeholder="Specify Vessel Name for this flag record"
                           v-model="newVesselFlag.vessel_name"
                    >
                    <span class="help-block" v-if="newVesselFlagErrors.vessel_name !== ''">
                      <small><strong>{{ newVesselFlagErrors.vessel_name }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': newVesselFlagErrors.date_from}">
                <label for="new-date-from" class="col col-sm-3 col-form-label font-weight-bolder">
                    Date From:
                </label>
                <div class="col col-sm-8 offset-1 col-form-label p-0">
                    <input type="date" id="new-date-from"
                           class="form-control form-control-xs"
                           v-model="newVesselFlag.date_from"
                    >
                    <span class="help-block" v-if="newVesselFlagErrors.date_from !== ''">
                      <small><strong>{{ newVesselFlagErrors.date_from }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': newVesselFlagErrors.date_to}">
                <label for="new-date-to" class="col col-sm-3 col-form-label font-weight-bolder">
                    Date To:
                </label>
                <div class="col col-sm-8 offset-1 col-form-label p-0">
                    <input type="date" id="new-date-to"
                           class="form-control form-control-xs"
                           v-model="newVesselFlag.date_to"
                    >
                    <span class="help-block" v-if="newVesselFlagErrors.date_to !== ''">
                      <small><strong>{{ newVesselFlagErrors.date_to }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': newVesselFlagErrors.country_id}">
                <label for="new-country" class="col col-sm-3 col-form-label font-weight-bolder">
                    Flag:
                </label>
                <div class="col col-sm-8 offset-1 col-form-label p-0">
                    <select id="new-country" class="form-control form-control-xs"
                            v-model="newVesselFlag.country_id"
                    >
                        <option :value="undefined">--- Select Flag ---</option>
                        <option v-for="countryKey in countryKeys" :key="countryKey.id"
                                :value="countryKey.id"
                        >
                            {{ countryKey.name }}
                        </option>
                    </select>
                    <span class="help-block" v-if="newVesselFlagErrors.country_id !== ''">
                      <small><strong>{{ newVesselFlagErrors.country_id }}</strong></small>
                    </span>
                </div>
            </div>

            <button type="submit" class="btn btn-warning btn-sm btn-xs mr-3 font-weight-bolder float-right" v-if="!guest && isPrincipal">
                <i class="fas fa-save"></i>
                Save
            </button>

        </form>


    </cms-modal>
</div>
</template>

<script>
/* eslint-disable */
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";
import { gateMixin } from "@/mixins/gateMixin";
import { mapActions, mapGetters} from "vuex";

import CmsModal from "@/components/elements/CmsModal";

export default {
    name: "AddFlagHistory",

    mixins: [ vueAppMixin, formMixin, gateMixin ],

    components: { CmsModal },

    data() {
        return {
            newVesselFlag: {},
            newVesselFlagErrors: {},
        }
    },

    methods: {
        ...mapActions([
            'addVesselFlag'
        ]),

        async confirmAddVesselFlag() {
            if(await this.confirmCreateAlert()) {
                let params = {
                    vessel_id: this.$route.params.id,
                    vessel_name: this.newVesselFlag.vessel_name,
                    date_from: this.newVesselFlag.date_from,
                    date_to: this.newVesselFlag.date_to,
                    country_id: this.newVesselFlag.country_id,
                };
                let newVesselFlag = await this.addVesselFlag(params);
                if(newVesselFlag) {
                    if(newVesselFlag.errors) {
                        this.newVesselFlagErrors = newVesselFlag.errors;
                    } else {
                        this.newVesselFlag = {};
                        this.successAlert('Vessel Flag Record Successfully Added', 'CREATE');
                        document.getElementById('close-add-vessel-flag').click();
                    }
                }
            }
        }
    },

    computed: {
        ...mapGetters([
            'countryKeys',
            'vesselInfo'
        ])
    }
}
</script>

<style scoped>

</style>
